<template>
<div>
  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Logistic</el-breadcrumb-item>
    <el-breadcrumb-item>Ready Goods List11</el-breadcrumb-item>
  </el-breadcrumb>
</el-col>
  <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col>
  </el-row>
  <!--卡片视图区域-->

  <el-card>
    <el-form :model="formInline" class="demo-form-inline">
      <!--IP user-->
    <div v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='J3P'">
<el-row>
<el-col :span = "6">
  <el-form-item label="Status:" label-width="115px">
            <el-select v-model="formInline.status" multiple collapse-tags
              style="margin-left: 0px;"
              placeholder="please choose">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            <span style="float: left">{{ item.label }}</span>
            <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.value }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      </el-col>
      <el-col :span = "6">
      <el-form-item label="Item:" label-width="115px">
        <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
      </el-form-item>
      </el-col>
      <el-col :span = "8">
        <el-form-item label="Item Description:" label-width="200px">
          <el-input v-model="formInline.itemDesc" placeholder="Item Description" clearable></el-input>
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span = "6">
        <el-form-item label="Supplier:" label-width="115px">
          <el-input v-model="formInline.supplier" placeholder="Supplier" clearable></el-input>
        </el-form-item>
        </el-col>
        <el-col :span = "6">
     <el-form-item label="Brand:" label-width="115px">
       <el-select v-model="formInline.brands" multiple collapse-tags
             style="margin-left: 0px;"  filterable
             placeholder="please choose">
           <el-option
           v-for="item in this.brandList"
           :key="item"
           :label="item"
           :value="item">
         </el-option>
       </el-select>
     </el-form-item>
      </el-col>
      <el-col :span = "8">
      <el-form-item label="Delivery Address:" label-width="200px">
        <el-select v-model="formInline.deliveryAddr" multiple collapse-tags
              style="margin-left: 0px;"   filterable
              placeholder="please choose">
            <el-option
              v-for="item in this.deliveryAddrList"
              :key="item.code"
              :label="item.code"
              :value="item.code">
              <span style="float: left; width: 30px;">{{ item.code }}</span>
              <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
              <!-- <span style="float: right; margin-right: 5px; color: #8492a6; font-size: 13px">{{ item.description }}</span> -->
            </el-option>
            <!-- <el-option
            v-for="item in statusList"
            :key="item.code"
            :label="item.code"
            :value="item.code">
            <span style="float: left; width: 30px;">{{ item.code }}</span>
            <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span> -->
        </el-select>
      </el-form-item>
      </el-col>
       </el-row>
      <el-row>
        <el-col :span = "24" style="margin-left: 430px;">
        <el-form-item >
          <el-button type="primary" @click="onSubmit">Search</el-button>
          <el-button type="primary" @click="exportToExcel">Excel</el-button>
         </el-form-item>
         </el-col>
      </el-row>
      </div>
      <div v-else>
<el-row>
<el-col :span = "6">
  <el-form-item label="Status:" label-width="115px">
            <el-select v-model="formInline.status" multiple collapse-tags
              style="margin-left: 0px;"
              placeholder="please choose">
            <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            <span style="float: left">{{ item.label }}</span>
            <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.value }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      </el-col>
      <el-col :span = "6">
      <el-form-item label="Item:" label-width="115px">
        <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
      </el-form-item>
      </el-col>
      <el-col :span = "8">
        <el-form-item label="Item Description:" label-width="200px">
          <el-input v-model="formInline.itemDesc" placeholder="Item Description" clearable></el-input>
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span = "6">
     <el-form-item label="Brand:" label-width="115px">
       <el-select v-model="formInline.brands" multiple collapse-tags
             style="margin-left: 0px;"  filterable
             placeholder="please choose">
           <el-option
           v-for="item in this.brandList"
           :key="item"
           :label="item"
           :value="item">
         </el-option>
       </el-select>
     </el-form-item>
      </el-col>
<el-col :span = "6">
      <el-form-item style="margin-left: 111px;">
        <el-button type="primary" @click="onSubmit">Search</el-button>
        <el-button type="primary" @click="exportToExcel">Excel</el-button>
      </el-form-item>
      </el-col>
      </el-row>
      </div>
    </el-form>
      <!-- Schedule 列表区域 -->
      <el-table :data="readygoodsList" border stripe style="width: 100%">
        <el-table-column type="index" label="#" fixed></el-table-column>
            <el-table-column   fixed
              prop="status"     sortable
              label="Status" :show-overflow-tooltip="true"
              width="85">
            </el-table-column>
            <el-table-column   fixed
              prop="deliveryAddr"
              label="Delivery address"     sortable
              width="135">
            </el-table-column>
            <!--IP user-->
            <el-table-column v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='J3P'"
              prop="supplier"  fixed
              label="Supplier"     sortable
              width="100">
            </el-table-column>
            <el-table-column  fixed
              prop="brand"
              label="Brand"     sortable
              width="79">
            </el-table-column>

            <el-table-column   fixed
              prop="intnlRef"     sortable
              label="Internal reference" :show-overflow-tooltip="true"
              width="135">
            </el-table-column>

            <el-table-column  fixed
              prop="item"     sortable
              label="Item" :show-overflow-tooltip="true"
              width="90">
            </el-table-column>

            <el-table-column
              prop="itemDesc"
              label="Item Description" :show-overflow-tooltip="true"
              width="129">
            </el-table-column>

            <el-table-column
              prop="schSeq"
              label="Sch. Seq"
              width="90">
            </el-table-column>

            <el-table-column
              prop="schDate"              :sortable="true"
              label="Sch Date"                   :sort-method="sortBySchDate"
              width="100" :formatter="dateFormat">
            </el-table-column>

            <el-table-column
              prop="schQ"
              label="Sch. Q" :show-overflow-tooltip="true"
              width="100">
            </el-table-column>

            <el-table-column
              prop="changeDate"              :sortable="true"
              label="Change Date"                   :sort-method="sortByChangeDate"
              width="110" :formatter="dateFormat">
            </el-table-column>

            <el-table-column
              prop="length"
              label="Length"     sortable
              width="90">
            </el-table-column>

            <el-table-column
              prop="width"
              label="Width"     sortable
              width="80">
            </el-table-column>

            <el-table-column
              prop="height"
              label="Height"     sortable
              width="90">
            </el-table-column>

            <el-table-column
              prop="carton"     :formatter="numFormat"
              label="Carton"     sortable
              width="90">
            </el-table-column>

            <el-table-column
              prop="nw"
              label="NW"     sortable
              width="80">
            </el-table-column>

            <el-table-column
              prop="gw"
              label="GW"     sortable
              width="70">
            </el-table-column>

            <el-table-column
              prop="volumn"
              label="Volume (CBM)"     sortable
              width="130">
            </el-table-column>

            <el-table-column
              prop="soldTo"
              label="Sold to"     sortable
              width="100">
            </el-table-column>

            <!-- <el-table-column
              prop="deliveryAddr"
              label="Delivery address"     sortable
              width="160">
            </el-table-column> -->

            <el-table-column
              prop="incotermCity"
              label="Incoterm City"     sortable
              width="136">
            </el-table-column>

            <el-table-column   v-if="this.userName.toUpperCase()==='J3P'"
              prop="temp"           :formatter="cargoFormat"
              label="Cargo"
              width="90">
            </el-table-column>

            <el-table-column   v-if="this.userName.toUpperCase()==='J3P'"
              prop="srf"
              label="SRF"     sortable
              width="85">
            </el-table-column>

          </el-table>

          <!-- 分页区域     :formatter="numFormat"-->
           <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        status: '',
        supplier: '',
        brands: [],
        deliveryAddr: [],
        item: '',
        itemDesc: '',
        token: '',
        page: 1,
        rows: 100
      },
      readygoodsList: [],
      brandList: [],
      deliveryAddrList: [],
      rfqTempList: [],
      userName: '',
      updateTime: '',
      total: 0,
      brandParam: {
        userName: '',
        userType: ''
      },
      options: [{
        value: 'DEV',
        label: 'Development',
        description: 'Development'
      }, {
        value: 'HLD',
        label: 'On Hold',
        description: 'On Hold'
      }, {
        value: 'LHK',
        label: 'Loading Hong Kong',
        description: 'Loading Hong Kong'
      }, {
        value: 'LSH',
        label: 'Loading Shanghai',
        description: 'Loading Shanghai'
      }, {
        value: 'LXI',
        label: 'Loading Xiamen',
        description: 'Loading Xiamen'
      }, {
        value: 'LYA',
        label: 'Loading Yantian',
        description: 'Loading Yantian'
      }, {
        value: 'NEW',
        label: 'New Order',
        description: 'New Order'
      }, {
        value: 'OKC',
        label: 'Confirmed to Close on arrival',
        description: 'Confirmed to Close on arrival'
      }, {
        value: 'OLO',
        label: 'On Line QC Pass',
        description: 'On Line QC Pass'
      }, {
        value: 'ONG',
        label: 'On Going Production',
        description: 'On Going Production'
      }, {
        value: 'PND',
        label: 'Pending for Approval',
        description: 'Pending for Approval'
      }, {
        value: 'PNO',
        label: 'Produce with Next Order',
        description: 'Produce with Next Order'
      }, {
        value: 'REJ',
        label: 'Reject',
        description: 'Reject'
      }, {
        value: 'RHK',
        label: 'Ready Hong Kong',
        description: 'Ready Hong Kong'
      }, {
        value: 'RSH',
        label: ' Ready Shanghai',
        description: ' Ready Shanghai'
      }, {
        value: 'RTC',
        label: 'Request to Close',
        description: 'Request to Close'
      }, {
        value: 'RXI',
        label: 'Ready Xiamen',
        description: 'Ready Xiamen'
      }, {
        value: 'RYA',
        label: 'Ready Yantian',
        description: 'Ready Yantian'
      }, {
        value: 'SFR',
        label: 'Shipment ready from France',
        description: 'Shipment ready from France'
      }, {
        value: 'SME',
        label: 'Shipment ready from Mexico',
        description: 'Shipment ready from Mexico'
      }, {
        value: 'TLB',
        label: 'Ready for Transfer to LB',
        description: 'Ready for Transfer to LB'
      }, {
        value: 'TYF',
        label: 'Ready for Transfer to Yufan',
        description: 'Ready for Transfer to Yufan'
      }, {
        value: 'WFC',
        label: 'Waiting for confirmation',
        description: 'Waiting for confirmation'
      }
      ],
      addressList: [],
      deliveryAddrArr: [{
        code: 'AD_2',
        description: 'IP Dayton'
      }, {
        code: 'AD_1',
        description: 'IP New York'
      }, {
        code: 'INT',
        description: 'IP Dayton'
      }, {
        code: 'TSM',
        description: 'TSM'
      }, {
        code: 'ENDEK',
        description: 'TSM'
      }, {
        code: 'FTZ',
        description: 'FTZ FG'
      }, {
        code: 'FTZ_1',
        description: 'FTZ COMPO'
      }, {
        code: 'LIFE',
        description: 'LB'
      }, {
        code: 'YFF',
        description: 'YF'
      }, {
        code: '3Star',
        description: '3Star'
      }, {
        code: 'CHI',
        description: 'ChiKwong'
      }, {
        code: 'EUROS',
        description: 'EUROS'
      }
      ]
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.getAddress()
    this.getReadygoodsList()
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getBrands()
    this.getDeliveryAddrList()
  },
  methods: {
    async getAddress () {
      const { data: res } = await this.$http.get('/common/addressList', { params: this.brandParam })
      this.addressList = await res.addressList
    },
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    async getDeliveryAddrList () {
      const { data: res } = await this.$http.get('/show/deliveryAddrList', { params: this.brandParam })
      var deliveryArr = await res.deliveryAddr
      /* setTimeout(() => {
        this.loading = false
        this.contactCRMList = this.contactCRMListbak.filter(item => {
          return item.supplier.toLowerCase()
            .indexOf(query.toLowerCase()) > -1 || item.companyName.toLowerCase()
            .indexOf(query.toLowerCase()) > -1 || item.shortDescr.toLowerCase()
            .indexOf(query.toLowerCase()) > -1
        })
      }, 200) */
      setTimeout(() => {
        for (var i = 0; i < deliveryArr.length; i++) {
          var flag = false
          for (var j = 0; j < this.addressList.length; j++) {
            if (deliveryArr[i].toUpperCase() === this.addressList[j].address.toUpperCase()) {
              flag = true
              this.deliveryAddrList.push({ code: deliveryArr[i], description: this.addressList[j].description })
              break
            }
          }
          if (!flag) {
            this.deliveryAddrList.push({ code: deliveryArr[i], description: '' })
          }
        }
      }, 200)
      for (var i = 0; i < deliveryArr.length; i++) {
        var flag = false
        for (var j = 0; j < this.addressList.length; j++) {
          if (deliveryArr[i].toUpperCase() === this.addressList[j].address.toUpperCase()) {
            flag = true
            this.deliveryAddrList.push({ code: deliveryArr[i], description: this.addressList[j].description })
            break
          }
        }
        if (!flag) {
          this.deliveryAddrList.push({ code: deliveryArr[i], description: '' })
        }
      }
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getReadygoodsList()
    },
    exportToExcel () {
      /* 表示在当前页面打开新地址51.68.206.7 https://www.myirequest.com */
      window.open('https://www.myirequest.com:8081/show/exportReadygoods?token=' + encodeURIComponent(this.formInline.token) +
        '&status=' + this.formInline.status + '&supplier=' + this.formInline.supplier + '&brand=' +
        this.formInline.brands + '&deliveryAddr=' +
        this.formInline.deliveryAddr + '&item=' + this.formInline.item + '&itemDesc=' + this.formInline.itemDesc, '_parent')
    },
    async getReadygoodsList () {
      var statusStr = ''
      if (this.formInline.status && this.formInline.status.length) {
        this.formInline.status = [...this.formInline.status].join(',')
        statusStr = this.formInline.status
      }
      var brandsStr = ''
      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandsStr = this.formInline.brands
      }
      var deliveryAddrStr = ''
      if (this.formInline.deliveryAddr && this.formInline.deliveryAddr.length) {
        this.formInline.deliveryAddr = [...this.formInline.deliveryAddr].join(',')
        deliveryAddrStr = this.formInline.deliveryAddr
      }
      const { data: res } = await this.$http.get('/show/readygoodsList', { params: this.formInline })
      this.readygoodsList = res.rows
      this.total = res.total
      this.rfqTempList = res.rfqTempList

      if (res.rows && this.readygoodsList[0]) {
        this.updateTime = this.readygoodsList[0].createTime
      }
      if (statusStr !== '') {
        await this.$set(this.formInline, 'status', statusStr.split(','))
      }
      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }
      if (deliveryAddrStr !== '') {
        await this.$set(this.formInline, 'deliveryAddr', deliveryAddrStr.split(','))
      }
    },
    numFormat (row, column, cellValue, index) {
      var numrc = row[column.property]
      if (numrc === null || numrc === '') {
        return
      }
      if (numrc.toString().indexOf('.') === -1) {
        return numrc
      }
      var result = ''
      var numrcStr = numrc.toString()
      numrc = numrcStr.substring(0, numrcStr.indexOf('.') + 3)
      return result
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '' || daterc === '1753/01/01 00:00:00' ||
      daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    cargoFormat (row, column, cellValue, index) {
      const cargorc = row[column.property]
      if (this.rfqTempList.indexOf(cargorc) > -1) {
        return 'Cargo'
      }
      return ''
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getReadygoodsList()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getReadygoodsList()
    },
    getMonth (month) {
      var monthLetter
      switch (month) {
        case '01':
          monthLetter = 'Jan'
          break
        case '02':
          monthLetter = 'Feb'
          break
        case '03':
          monthLetter = 'Mar'
          break
        case '04':
          monthLetter = 'Apr'
          break
        case '05':
          monthLetter = 'May'
          break
        case '06':
          monthLetter = 'Jun'
          break
        case '07':
          monthLetter = 'Jul'
          break
        case '08':
          monthLetter = 'Aug'
          break
        case '09':
          monthLetter = 'Sep'
          break
        case 10:
          monthLetter = 'Oct'
          break
        case 11:
          monthLetter = 'Nov'
          break
        case 12:
          monthLetter = 'Dec'
          break
      }
      return monthLetter
    },
    sortBySchDate (obj1, obj2) {
      var val1 = Math.floor(new Date(obj1.schDate).getTime() / 1000)
      var val2 = Math.floor(new Date(obj2.schDate).getTime() / 1000)
      return val1 - val2
    },
    sortByChangeDate (obj1, obj2) {
      var val1 = Math.floor(new Date(obj1.changeDate).getTime() / 1000)
      var val2 = Math.floor(new Date(obj2.changeDate).getTime() / 1000)
      return val1 - val2
    }

    // dateFormat (value) {
    //   if (value === null || value === '') {
    //     return ''
    //   }
    //   var date = new Date(value) // long转换成date
    //   var year = date.getFullYear().toString()
    //   var month = (date.getMonth() + 1)
    //   var day = date.getDate().toString()
    //   if (month < 10) {
    //     month = '0' + month
    //   }
    //   if (day < 10) {
    //     day = '0' + day
    //   }
    //   return year + '/' + month + '/' + day
    // }
  }
}
</script>

<style>
</style>
